import { MediumIcon } from "../IconSizes";

export const stenaUser: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM21 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L5 22 5 19C5 16.79 6.79 15 9 15L15 15C17.21 15 19 16.79 19 19L19 22 21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM15 17L9 17C7.9 17 7 17.9 7 19L7 22 17 22 17 19C17 17.9 16.1 17 15 17ZM12 5C14.21 5 16 6.79 16 9 16 11.21 14.21 13 12 13 9.79 13 8 11.21 8 9 8 6.79 9.79 5 12 5ZM12 7C10.9 7 10 7.9 10 9 10 10.1 10.9 11 12 11 13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserAdd: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 13C13.21 13 15 14.79 15 17L15 20C15 20.55 14.55 21 14 21 13.45 21 13 20.55 13 20L13 17C13 15.9 12.1 15 11 15L5 15C3.9 15 3 15.9 3 17L3 20C3 20.55 2.55 21 2 21 1.45 21 1 20.55 1 20L1 17C1 14.79 2.79 13 5 13L11 13ZM19 6.83C19.55 6.83 20 7.28 20 7.83L20 10 22.17 10C22.72 10 23.17 10.45 23.17 11 23.17 11.55 22.72 12 22.17 12L20 12 20 14.17C20 14.72 19.55 15.17 19 15.17 18.45 15.17 18 14.72 18 14.17L18 12 15.83 12C15.28 12 14.83 11.55 14.83 11 14.83 10.45 15.28 10 15.83 10L18 10 18 7.83C18 7.28 18.45 6.83 19 6.83ZM8 3C10.21 3 12 4.79 12 7 12 9.21 10.21 11 8 11 5.79 11 4 9.21 4 7 4 4.79 5.79 3 8 3ZM8 5C6.9 5 6 5.9 6 7 6 8.1 6.9 9 8 9 9.1 9 10 8.1 10 7 10 5.9 9.1 5 8 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserCircle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM15 17L9 17C7.9 17 7 17.9 7 19L7 20.66C8.47 21.51 10.18 22 12 22 13.82 22 15.53 21.51 17 20.66L17 19C17 17.9 16.1 17 15 17ZM12 2C6.48 2 2 6.48 2 12 2 14.8 3.15 17.33 5 19.14L5 19C5 16.79 6.79 15 9 15L15 15C17.21 15 19 16.79 19 19L19 19.14C20.85 17.33 22 14.8 22 12 22 6.48 17.52 2 12 2ZM12 5C14.21 5 16 6.79 16 9 16 11.21 14.21 13 12 13 9.79 13 8 11.21 8 9 8 6.79 9.79 5 12 5ZM12 7C10.9 7 10 7.9 10 9 10 10.1 10.9 11 12 11 13.1 11 14 10.1 14 9 14 7.9 13.1 7 12 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserGroupLarge: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16 14C18.21 14 20 15.79 20 18L20 21C20 21.55 19.55 22 19 22 18.45 22 18 21.55 18 21L18 18C18 16.9 17.1 16 16 16L8 16C6.9 16 6 16.9 6 18L6 21C6 21.55 5.55 22 5 22 4.45 22 4 21.55 4 21L4 18C4 15.79 5.79 14 8 14L16 14ZM20 10C22.21 10 24 11.79 24 14L24 15C24 15.55 23.55 16 23 16 22.45 16 22 15.55 22 15L22 14C22 12.9 21.1 12 20 12L19 12C18.45 12 18 11.55 18 11 18 10.45 18.45 10 19 10L20 10ZM5 10C5.55 10 6 10.45 6 11 6 11.55 5.55 12 5 12L4 12C2.9 12 2 12.9 2 14L2 15C2 15.55 1.55 16 1 16 0.45 16 0 15.55 0 15L0 14C0 11.79 1.79 10 4 10L5 10ZM12 4C14.21 4 16 5.79 16 8 16 10.21 14.21 12 12 12 9.79 12 8 10.21 8 8 8 5.79 9.79 4 12 4ZM12 6C10.9 6 10 6.9 10 8 10 9.1 10.9 10 12 10 13.1 10 14 9.1 14 8 14 6.9 13.1 6 12 6ZM20 2C21.66 2 23 3.34 23 5 23 6.66 21.66 8 20 8 18.34 8 17 6.66 17 5 17 3.34 18.34 2 20 2ZM4 2C5.66 2 7 3.34 7 5 7 6.66 5.66 8 4 8 2.34 8 1 6.66 1 5 1 3.34 2.34 2 4 2ZM20 4C19.45 4 19 4.45 19 5 19 5.55 19.45 6 20 6 20.55 6 21 5.55 21 5 21 4.49 20.61 4.06 20.12 4.01L20 4ZM4 4L3.88 4.01C3.39 4.06 3 4.49 3 5 3 5.55 3.45 6 4 6 4.55 6 5 5.55 5 5 5 4.45 4.55 4 4 4Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserGroupSmall: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11 15C13.21 15 15 16.79 15 19L15 21C15 21.55 14.55 22 14 22 13.45 22 13 21.55 13 21L13 19C13 17.9 12.1 17 11 17L5 17C3.9 17 3 17.9 3 19L3 21C3 21.55 2.55 22 2 22 1.45 22 1 21.55 1 21L1 19C1 16.79 2.79 15 5 15L11 15ZM19 11C21.21 11 23 12.79 23 15L23 16C23 16.55 22.55 17 22 17 21.45 17 21 16.55 21 16L21 15C21 13.9 20.1 13 19 13L16 13C15.45 13 15 12.55 15 12 15 11.45 15.45 11 16 11L19 11ZM8 5C10.21 5 12 6.79 12 9 12 11.21 10.21 13 8 13 5.79 13 4 11.21 4 9 4 6.79 5.79 5 8 5ZM8 7C6.9 7 6 7.9 6 9 6 10.1 6.9 11 8 11 9.1 11 10 10.1 10 9 10 7.9 9.1 7 8 7ZM18 3C19.66 3 21 4.34 21 6 21 7.66 19.66 9 18 9 16.34 9 15 7.66 15 6 15 4.34 16.34 3 18 3ZM18 5C17.45 5 17 5.45 17 6 17 6.55 17.45 7 18 7 18.55 7 19 6.55 19 6 19 5.49 18.61 5.06 18.12 5.01L18 5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserMultiple: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10 16C12.21 16 14 17.79 14 20L14 22C14 22.55 13.55 23 13 23 12.45 23 12 22.55 12 22L12 20C12 18.9 11.1 18 10 18L4 18C2.9 18 2 18.9 2 20L2 22C2 22.55 1.55 23 1 23 0.45 23 0 22.55 0 22L0 20C0 17.79 1.79 16 4 16L10 16ZM20 12C22.21 12 24 13.79 24 16L24 18C24 18.55 23.55 19 23 19 22.45 19 22 18.55 22 18L22 16C22 14.9 21.1 14 20 14L15 14C14.45 14 14 13.55 14 13 14 12.45 14.45 12 15 12L20 12ZM7 4C9.76 4 12 6.24 12 9 12 11.76 9.76 14 7 14 4.24 14 2 11.76 2 9 2 6.24 4.24 4 7 4ZM7 6C5.34 6 4 7.34 4 9 4 10.66 5.34 12 7 12 8.66 12 10 10.66 10 9 10 7.34 8.66 6 7 6ZM18.5 1C20.99 1 23 3.01 23 5.5 23 7.99 20.99 10 18.5 10 16.01 10 14 7.99 14 5.5 14 3.01 16.01 1 18.5 1ZM18.5 3C17.12 3 16 4.12 16 5.5 16 6.88 17.12 8 18.5 8 19.88 8 21 6.88 21 5.5 21 4.12 19.88 3 18.5 3Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUserSingle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 2C14.76 2 17 4.24 17 7 17 9.76 14.76 12 12 12 9.24 12 7 9.76 7 7 7 4.24 9.24 2 12 2ZM12 4C10.34 4 9 5.34 9 7 9 8.66 10.34 10 12 10 13.66 10 15 8.66 15 7 15 5.34 13.66 4 12 4ZM20 21C20 21.55 19.55 22 19 22 18.45 22 18 21.55 18 21L18 18C18 16.9 17.1 16 16 16L8 16C6.9 16 6 16.9 6 18L6 21C6 21.55 5.55 22 5 22 4.45 22 4 21.55 4 21L4 18C4 15.79 5.79 14 8 14L16 14C18.21 14 20 15.79 20 18L20 21Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaUsers: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M21 0C22.66 0 24 1.34 24 3L24 21C24 22.66 22.66 24 21 24L3 24C1.34 24 0 22.66 0 21L0 3C0 1.34 1.34 0 3 0L21 0ZM21 2L3 2C2.45 2 2 2.45 2 3L2 21C2 21.55 2.45 22 3 22L21 22C21.55 22 22 21.55 22 21L22 3C22 2.45 21.55 2 21 2ZM9 14C10.66 14 12 15.34 12 17L12 18C12 18.55 11.55 19 11 19 10.45 19 10 18.55 10 18L10 17C10 16.45 9.55 16 9 16L7 16C6.45 16 6 16.45 6 17L6 18C6 18.55 5.55 19 5 19 4.45 19 4 18.55 4 18L4 17C4 15.34 5.34 14 7 14L9 14ZM18 15C18 14.45 17.55 14 17 14L14 14C13.45 14 13 13.55 13 13 13 12.45 13.45 12 14 12L17 12C18.66 12 20 13.34 20 15L20 17C20 17.55 19.55 18 19 18 18.45 18 18 17.55 18 17L18 15ZM8 7C9.66 7 11 8.34 11 10 11 11.66 9.66 13 8 13 6.34 13 5 11.66 5 10 5 8.34 6.34 7 8 7ZM8 9C7.45 9 7 9.45 7 10 7 10.55 7.45 11 8 11 8.55 11 9 10.55 9 10 9 9.49 8.61 9.06 8.12 9.01L8 9ZM16 5C17.66 5 19 6.34 19 8 19 9.66 17.66 11 16 11 14.34 11 13 9.66 13 8 13 6.34 14.34 5 16 5ZM16 7C15.45 7 15 7.45 15 8 15 8.55 15.45 9 16 9 16.55 9 17 8.55 17 8 17 7.49 16.61 7.06 16.12 7.01L16 7Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};
